var map = {
	"./assets/css/style.less": "a7c1",
	"./assets/css/title.less": "56c4",
	"./assets/css/transition.less": "afcb",
	"./assets/fonts/DIGITAL.TXT": "292e",
	"./assets/fonts/DS-DIGI.TTF": "2f51",
	"./assets/fonts/DS-DIGIB.TTF": "2650",
	"./assets/fonts/DS-DIGII.TTF": "b51f",
	"./assets/fonts/DS-DIGIT.TTF": "6ce2",
	"./assets/fonts/Jost-Bold.ttf": "9fe8",
	"./assets/fonts/Jost-Medium.ttf": "e4cd",
	"./assets/fonts/Oswald-Medium.ttf": "2aa1",
	"./assets/fonts/PingFang SC Regular.ttf": "98bd",
	"./assets/fonts/PingFang/PingFang Bold.ttf": "ba8f",
	"./assets/fonts/PingFang/PingFang ExtraLight.ttf": "b83c",
	"./assets/fonts/PingFang/PingFang Heavy.ttf": "4ce8",
	"./assets/fonts/PingFang/PingFang Regular.ttf": "dcf5",
	"./assets/fonts/PingFang/PingFangMedium.ttf": "9342",
	"./assets/fonts/SentyTEA.woff2": "509f",
	"./assets/fonts/UnidreamLED/UnidreamLED.eot": "d767",
	"./assets/fonts/UnidreamLED/UnidreamLED.woff": "bc21",
	"./assets/fonts/YouSheBiaoTiHei.ttf": "7822",
	"./assets/fonts/akrobat-bold.ttf": "c484",
	"./assets/fonts/akrobat-regular.ttf": "755d",
	"./assets/img/ai_listen.gif": "65ff",
	"./assets/img/back.svg": "a11e",
	"./assets/img/bg3.png": "7d5d",
	"./assets/img/bgLogo.svg": "5ff4",
	"./assets/img/bossImg.png": "5886e",
	"./assets/img/common/quit.svg": "cc28",
	"./assets/img/common/toLeft-icon.svg": "0fbc",
	"./assets/img/common/toRight-icon.svg": "de05",
	"./assets/img/demoImg/demo_logo.svg": "176c",
	"./assets/img/demoImg/team1.svg": "4f94",
	"./assets/img/demoImg/team2.svg": "282f",
	"./assets/img/demoImg/test.png": "f195",
	"./assets/img/demoImg/test1.png": "0f85",
	"./assets/img/demoImg/test2.png": "6efc",
	"./assets/img/face.png": "257e",
	"./assets/img/faceGif.gif": "a96e",
	"./assets/img/gif/loading.gif": "d286",
	"./assets/img/hand.gif": "ced3",
	"./assets/img/handAi/01.png": "4493",
	"./assets/img/handAi/02.png": "b9e5",
	"./assets/img/handAi/03.png": "be7d",
	"./assets/img/handAi/04.png": "d90b",
	"./assets/img/handAi/05.png": "aa83",
	"./assets/img/handAi/06.png": "90be",
	"./assets/img/handAi/07.png": "f846",
	"./assets/img/handAi/08.png": "68c8",
	"./assets/img/handAi/09.png": "3652",
	"./assets/img/handAi/10.png": "b75c",
	"./assets/img/handAi/11.png": "1f1a",
	"./assets/img/handAi/12.png": "fbeb",
	"./assets/img/handAi/13.png": "801e",
	"./assets/img/handAi/14.png": "207c",
	"./assets/img/handAi/15.png": "f405",
	"./assets/img/handAi/16.png": "5139",
	"./assets/img/handAi/17.png": "e7d9",
	"./assets/img/handAi/18.png": "581f",
	"./assets/img/handAi/19.png": "acfe",
	"./assets/img/handAi/20.png": "360a",
	"./assets/img/handAi/21.png": "a165",
	"./assets/img/handAi/22.png": "265c",
	"./assets/img/handAi/23.png": "cc7b",
	"./assets/img/handAi/24.png": "bfa3",
	"./assets/img/handAi/25.png": "fe8a",
	"./assets/img/handAi/26.png": "4f54",
	"./assets/img/handAi/27.png": "6da9",
	"./assets/img/handAi/28.png": "c658",
	"./assets/img/handAi/29.png": "809b",
	"./assets/img/handAi/30.png": "f92b",
	"./assets/img/handAi/31.png": "7918",
	"./assets/img/handAi/32.png": "d5d8",
	"./assets/img/handAi/33.png": "a471",
	"./assets/img/handAi/34.png": "0448",
	"./assets/img/handAi/35.png": "333e",
	"./assets/img/handAi/36.png": "eed8",
	"./assets/img/handAi/37.png": "039e",
	"./assets/img/handAi/38.png": "6a72",
	"./assets/img/handAi/39.png": "3b97",
	"./assets/img/handAi/40.png": "b193",
	"./assets/img/handAi/41.png": "356b",
	"./assets/img/handAi/42.png": "36be",
	"./assets/img/handAi/43.png": "8699",
	"./assets/img/handAi/44.png": "2b56",
	"./assets/img/handAi/45.png": "a367",
	"./assets/img/handAi/46.png": "3205",
	"./assets/img/handAi/47.png": "7882",
	"./assets/img/handAi/48.png": "0f4c",
	"./assets/img/handAi/49.png": "cb76",
	"./assets/img/handAi/50.png": "2d1e",
	"./assets/img/icon/exercises.svg": "5fe4",
	"./assets/img/icon/gpsReports.svg": "c1af",
	"./assets/img/icon/matches.svg": "c806",
	"./assets/img/icon/physicalTests.svg": "a6df",
	"./assets/img/icon/playerEval.svg": "fd10",
	"./assets/img/icon/questionnaires.svg": "cd28",
	"./assets/img/icon/trainingDays.svg": "d43b",
	"./assets/img/icon/trainingDuration.svg": "0b8a",
	"./assets/img/icon/trainingVideos.svg": "6a54",
	"./assets/img/icon/videoIcon.svg": "85ae",
	"./assets/img/img.gif": "0a89",
	"./assets/img/lineup/Vector.svg": "e7b9",
	"./assets/img/lineup/bg.png": "09c2",
	"./assets/img/lineup/empty-avatar.svg": "6da2",
	"./assets/img/lineup/trial.svg": "cf35",
	"./assets/img/loginUserBg.png": "bc73",
	"./assets/img/logoIcon.png": "017b2",
	"./assets/img/logo_beijing.svg": "d85b",
	"./assets/img/logo_guoan.svg": "b84e",
	"./assets/img/mark_Img.png": "ad1e",
	"./assets/img/mark_Img.svg": "83e1",
	"./assets/img/mky.png": "04f1",
	"./assets/img/moment/1.png": "b53c",
	"./assets/img/moment/2.png": "1afc",
	"./assets/img/navImg/ac-aim.svg": "aaf5",
	"./assets/img/navImg/ac.svg": "add7",
	"./assets/img/navImg/agility.svg": "0746",
	"./assets/img/navImg/antro.svg": "61b4",
	"./assets/img/navImg/aphv.svg": "6628",
	"./assets/img/navImg/matchData.svg": "c473",
	"./assets/img/navImg/nav1.svg": "81d3",
	"./assets/img/navImg/nav10.svg": "417e",
	"./assets/img/navImg/nav11.svg": "fad2",
	"./assets/img/navImg/nav12.svg": "b92b",
	"./assets/img/navImg/nav13.svg": "04ff",
	"./assets/img/navImg/nav14.svg": "b0b5",
	"./assets/img/navImg/nav15.svg": "f7a3",
	"./assets/img/navImg/nav16.svg": "6203",
	"./assets/img/navImg/nav17.svg": "1c24",
	"./assets/img/navImg/nav18.svg": "0ba9",
	"./assets/img/navImg/nav19.svg": "fd9a",
	"./assets/img/navImg/nav2.svg": "e623",
	"./assets/img/navImg/nav3.svg": "b476",
	"./assets/img/navImg/nav4.svg": "a8d9",
	"./assets/img/navImg/nav5.svg": "c16e",
	"./assets/img/navImg/nav6.svg": "d056",
	"./assets/img/navImg/nav7.svg": "4c0c",
	"./assets/img/navImg/nav8.svg": "50ec",
	"./assets/img/navImg/nav9.svg": "4ce1",
	"./assets/img/navImg/playerData.svg": "70db",
	"./assets/img/navImg/speed.svg": "4292",
	"./assets/img/navImg/strong.svg": "5a2e",
	"./assets/img/navImg/teamData.svg": "c138",
	"./assets/img/navImg/yoyo.svg": "752e",
	"./assets/img/numBg.svg": "8984",
	"./assets/img/page/next.svg": "2c0f",
	"./assets/img/page/page.svg": "8865",
	"./assets/img/page/prev.svg": "5196",
	"./assets/img/playerImg/1.svg": "a6bb",
	"./assets/img/playerImg/2.svg": "3c72",
	"./assets/img/playerImg/3.svg": "b595",
	"./assets/img/playerImg/4.svg": "3634",
	"./assets/img/playerImg/bg1.svg": "ab2b",
	"./assets/img/playerImg/bg2.svg": "f1a1",
	"./assets/img/playerImg/center.svg": "c92e",
	"./assets/img/playerImg/forward.svg": "3b0c",
	"./assets/img/playerImg/goalkeeper.svg": "4f6c",
	"./assets/img/playerImg/guard.svg": "e6cd",
	"./assets/img/playerImg/loginIcon.png": "bf51",
	"./assets/img/playerImg/logoIcon.png": "c6a3",
	"./assets/img/playerImg/player.png": "8407",
	"./assets/img/playerImg/staffPosition.svg": "1eca",
	"./assets/img/playerImg/titleBg.png": "bc6f",
	"./assets/img/ppp.png": "0dc8",
	"./assets/img/reportImg/Calendar.svg": "108f",
	"./assets/img/reportImg/bodyImg.png": "e861",
	"./assets/img/reportImg/bodyImg2.png": "9183",
	"./assets/img/reportImg/bodyImg3.png": "3e53",
	"./assets/img/reportImg/injuryBody1.png": "95fd",
	"./assets/img/reportImg/injuryBody2.png": "bb04",
	"./assets/img/reportImg/injuryBody3.png": "76f6",
	"./assets/img/reportImg/line.svg": "9e29",
	"./assets/img/reportImg/promptIcon.png": "fe9c",
	"./assets/img/reportImg/scheduleWorkItem.png": "44bc",
	"./assets/img/reportImg/xingFull.svg": "45a5",
	"./assets/img/reportImg/xingHalf.svg": "5388",
	"./assets/img/reportImg/xingNo.svg": "03e8",
	"./assets/img/smartPitch/SmartPitch.svg": "ae75",
	"./assets/img/taskAi.rar": "99ac",
	"./assets/img/taskAi/01.png": "5636",
	"./assets/img/taskAi/02.png": "33e1",
	"./assets/img/taskAi/03.png": "0b88",
	"./assets/img/taskAi/04.png": "d66f",
	"./assets/img/taskAi/05.png": "0a2a",
	"./assets/img/taskAi/06.png": "ef6e",
	"./assets/img/taskAi/07.png": "193c",
	"./assets/img/taskAi/08.png": "3f37",
	"./assets/img/taskAi/09.png": "a2a6",
	"./assets/img/taskAi/10.png": "8e50",
	"./assets/img/taskAi/11.png": "e213",
	"./assets/img/taskAi/12.png": "463b",
	"./assets/img/taskAi/13.png": "19eb",
	"./assets/img/taskAi/14.png": "a8a3",
	"./assets/img/taskAi/15.png": "17dd",
	"./assets/img/teams/bg.svg": "104a",
	"./assets/img/teams/club.svg": "6383",
	"./assets/img/teams/first_team.svg": "3776",
	"./assets/img/teams/guo.svg": "8d11",
	"./assets/img/teams/juvenile.svg": "224f",
	"./assets/img/teams/playerPositionbg.svg": "0883",
	"./assets/img/teams/smartPitch.svg": "8b25",
	"./assets/img/teams/teams.svg": "2e08",
	"./assets/img/teams/training_camp.svg": "e333",
	"./assets/img/teams/youth.svg": "70a1",
	"./assets/img/testImg.png": "e573",
	"./assets/img/testImgLogin.png": "2ba8",
	"./assets/img/trainingIcon/basketballTraining.svg": "3189",
	"./assets/img/trainingIcon/basketballTrainingCol.svg": "2357",
	"./assets/img/trainingIcon/dayoff.svg": "a3b0",
	"./assets/img/trainingIcon/dayoffCol.svg": "299b",
	"./assets/img/trainingIcon/holiday.svg": "b901",
	"./assets/img/trainingIcon/holidayCol.svg": "eb52",
	"./assets/img/trainingIcon/match.svg": "86b1",
	"./assets/img/trainingIcon/matchCol.svg": "a3e5",
	"./assets/img/trainingIcon/meeting.svg": "fbd0",
	"./assets/img/trainingIcon/meetingCol.svg": "6357",
	"./assets/img/trainingIcon/physicalTraining.svg": "e252",
	"./assets/img/trainingIcon/physicalTrainingCol.svg": "22bf",
	"./assets/img/trainingIcon/travel.svg": "a033",
	"./assets/img/trainingIcon/travelCol.svg": "ddfc",
	"./assets/img/updateImg/LINE.svg": "e211",
	"./assets/img/updateImg/arrow_left.svg": "88f5",
	"./assets/img/updateImg/arrow_right.svg": "9725",
	"./assets/img/updateImg/bg1.png": "ed1e",
	"./assets/img/updateImg/bg2.png": "857f",
	"./assets/img/updateImg/bg3.png": "bebd",
	"./assets/img/updateImg/chart_1.svg": "e79c",
	"./assets/img/updateImg/chart_2.svg": "8389",
	"./assets/img/updateImg/ellipsis.svg": "3bf3",
	"./assets/img/updateImg/exerciseBg.png": "b59d",
	"./assets/img/updateImg/forward.svg": "9d99",
	"./assets/img/updateImg/game.svg": "480d",
	"./assets/img/updateImg/game_head.png": "faaa",
	"./assets/img/updateImg/goalkeeper.svg": "b0aa",
	"./assets/img/updateImg/greenCircle.svg": "127f",
	"./assets/img/updateImg/guard.svg": "5f51",
	"./assets/img/updateImg/headImg.svg": "5f6b",
	"./assets/img/updateImg/head_1.png": "6a542",
	"./assets/img/updateImg/head_2.png": "0c68",
	"./assets/img/updateImg/head_3.png": "bf65",
	"./assets/img/updateImg/head_4.png": "be55",
	"./assets/img/updateImg/head_5.png": "af7b",
	"./assets/img/updateImg/head_6.png": "2a45",
	"./assets/img/updateImg/hot.svg": "417e0",
	"./assets/img/updateImg/injuryPersonal.png": "25e8",
	"./assets/img/updateImg/logo.svg": "3b8b",
	"./assets/img/updateImg/menuBg.svg": "98e9",
	"./assets/img/updateImg/midfield.svg": "5681",
	"./assets/img/updateImg/personal.png": "fc6a",
	"./assets/img/updateImg/personal.svg": "dbb5",
	"./assets/img/updateImg/personalLittle.png": "bb02",
	"./assets/img/updateImg/personalLittle.svg": "84ac",
	"./assets/img/updateImg/playerHead.png": "9b92",
	"./assets/img/updateImg/playerMsg.svg": "19b1",
	"./assets/img/updateImg/redCircle.svg": "59b2",
	"./assets/img/updateImg/soccer.svg": "cb6d",
	"./assets/img/updateImg/teach_head.svg": "2d56",
	"./assets/img/updateImg/team.svg": "2c82",
	"./assets/img/updateImg/teamIntroduce.svg": "f2b9",
	"./assets/img/updateImg/xing.svg": "fc54",
	"./assets/img/updateImg/xingFull.svg": "932f",
	"./assets/img/updateImg/xingHalf.svg": "5294",
	"./assets/img/updateImg/xingNo.svg": "b7c4",
	"./assets/img/updateImg/编组.svg": "69ae",
	"./assets/js/generated/RealTimeChatServiceServiceClientPb.ts": "20cb",
	"./assets/js/generated/RealTimeChatService_pb": "a0ff",
	"./assets/js/generated/RealTimeChatService_pb.d.ts": "0f7e",
	"./assets/js/generated/RealTimeChatService_pb.js": "a0ff",
	"./assets/js/global": "f524",
	"./assets/js/global.js": "f524",
	"./assets/js/practice/data": "5c78",
	"./assets/js/practice/data.js": "5c78",
	"./assets/js/protos/RealTimeChat/RealTimeChatService.proto": "b1b0",
	"./assets/js/record": "f230",
	"./assets/js/record.js": "f230",
	"./assets/js/utils/pcm_utils.ts": "5958",
	"./assets/js/utils/player_utils.ts": "f9f9",
	"./assets/json/ai": "34b4",
	"./assets/json/ai.json": "34b4",
	"./assets/json/img": "ed91",
	"./assets/json/img.js": "ed91",
	"./assets/json/static": "bc80",
	"./assets/json/static.json": "bc80",
	"./assets/json/test": "b188",
	"./assets/json/test.json": "b188",
	"./assets/logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";